import React from "react";

const Loader = () => {
    return (
        <div className="h-full w-full flex items-center justify-center z-50 ml-1 mr-1">
            <div className="loading" />
        </div>
    );
};

export default Loader;
